import { useEffect, useState } from "react";

import { useRouter } from "@lib/router";

import { ORDER_PREFILL_QUERY_PARAM } from "../../constants";
import { TPrefillData } from "../../models/prefillData";
import decodePrefillData from "../../utils/decodePrefillData";

const usePrefillData = (): TPrefillData | undefined => {
  const [prefillData, setPrefillData] = useState<TPrefillData>();

  const { query } = useRouter();

  useEffect(() => {
    const prefillQueryData = query[ORDER_PREFILL_QUERY_PARAM] as string;
    if (!prefillQueryData) {
      return;
    }

    const newPrefillData = decodePrefillData(prefillQueryData);
    setPrefillData(newPrefillData || undefined);
  }, [query]);

  return prefillData;
};
export default usePrefillData;
